<template>
    <div>
        <Filters ref="Filters" />
        <Results ref="Results" />
    </div>
</template>



<script>
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        code: null,
        name: null,
        city: null,
        zip: null,
        address: null,
        hide: [],
        campaigns: [],
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 25,
        page: 1,
        sort: 'id',
        order: 'DESC',
    });

    export default {
        name: 'OfflineLocations',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('campaigns/offlineLocation'),
            };
        },
        computed: {
            urlParams() {
                return { campaignId: Number.parseInt(this.$route.params.id) };
            },
        },
        watch: {
            items() {
                this.$set(this.parentComponent.item, 'offline-locations', this.items);
            },
            loading() {
                this.$store.commit('campaigns/setLoading', { key: 'offlineLocation', value: this.loading });
            },
        },
    };
</script>
